import { render, staticRenderFns } from "./admin-products.vue?vue&type=template&id=2786706e"
import script from "./admin-products.vue?vue&type=script&lang=js"
export * from "./admin-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports